import { CheckBox } from "components/CheckBox/CheckBox";
import { DateTimePickerField } from "components/DateTime/DateTimePicker";
import { InputField } from "components/InputField/InputField";
import InfoTooltip from "components/InfoTooltip";
import { getDateTimeFormat, getDateTimeFormatForDatePicket, maskDateTime, toEtPickerDate, floorPickerTime } from "helper/dateFormat";
import React from "react";
import { Footer } from "../Footer/Footer";
import { CampaignSectionWrapper, CheckBoxWrapper, FooterWrapepr, Title, Wrapper } from "./Theme";
export const CreateCampaignForm = ({ formik,onNext,onBack }) => {
  const etNow = toEtPickerDate(new Date());
  const dateTimeMask = maskDateTime();
  const placeholderFormat = getDateTimeFormat();
  const dateFormat = getDateTimeFormatForDatePicket()
  const buttons = [
    {
      name: "Previous",
      action: () => {
        onBack();
      },
      isDisabled:false,
      type: "secondary",
      width:'100px',
      marginRight: "42rem",
      variant : "primary-outline"
    },
    {
      name: "Next",
      action: () => {
        onNext();
      },
      isDisabled:!formik.values?.campainName ||
            (formik?.values?.scheduledCampaign && !formik.values?.emailDate),
      type: "primary",
      width:'100px',
      variant : "primary"
    },
  ];
  const selectedDate = formik.values?.emailDate || null;
  const isToday = !selectedDate || new Date(selectedDate).toDateString() === etNow.toDateString();
  const minTime = isToday ? floorPickerTime(etNow) : new Date(etNow.getFullYear(), etNow.getMonth(), etNow.getDate(), 0, 0, 0, 0);
  const maxTime = new Date(etNow.getFullYear(), etNow.getMonth(), etNow.getDate(), 23, 59, 0, 0);
  const etNowMinutes = etNow.getHours() * 60 + etNow.getMinutes();
  const minDate = new Date(etNow.getFullYear(), etNow.getMonth(), etNow.getDate());

  return (
    <Wrapper>
      <Title>Create Campaign</Title>
      <CampaignSectionWrapper>
        <InputField
          mandatory
          label={`Campaign Name`}
          type="text"
          formik={formik}
          value={formik.values?.campainName}
          message={"Please enter valid email"}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          style={{
            width: "312px",
            height: "48px",
          }}
          styleWrapper={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: "1px",
            justifyContent: "center",
          }}
          Wrapper={{ alignItems: "baseline" }}
          labelStyle={{
            color: "#002E5C",
            fontSize: "14px",
            fontWeight: 400,
          }}
          onChange={(e) => {
            formik.setFieldValue("campainName", e.target.value);
          }}
        />
        <CheckBoxWrapper>
          <CheckBox
            checked={formik?.values?.scheduledCampaign}
            onChange={() => {
              formik.setFieldValue(
                "scheduledCampaign",
                !formik?.values?.scheduledCampaign
              );
              formik.setFieldValue("emailDate", null);
            }}
            text="Scheduled Campaign"
          />
          <InfoTooltip text="Pick a future date and time to send this campaign, instead of sending it right away." style={{ marginLeft: '6px', marginBottom: '8px' }} />
        </CheckBoxWrapper>
      </CampaignSectionWrapper>
      <br />
      {formik?.values?.scheduledCampaign && (
        <div style={{ width: "80%" }}>
          <hr />
          <DateTimePickerField
            mandatory={true}
            showIcon
            {...{
              formik,
              title: "Campaign date/time ( ET timezone) ",
              name: "emailDate",
            }}
            checkValidation={true}
            selected={selectedDate}
            onChange={(e) => {
              formik.setFieldValue("emailDate", e);
            }}
            minDate={minDate}
            minTime={minTime}
            maxTime={maxTime}
            filterTime={isToday ? (time) => time.getHours() * 60 + time.getMinutes() >= etNowMinutes : undefined}
            showTimeSelect={true}
            dateFormat={dateFormat}
            placeholderText={placeholderFormat}
            mask={dateTimeMask}
          />
        </div>
      )}
      <FooterWrapepr>
      <Footer buttons={buttons}  type="My template"
      Wrapperstyle={{width:'108%'}}
      />
      </FooterWrapepr>
      
    </Wrapper>
  );
};
